<template>
  <div>
    <h3 class="text-lg leading-6 font-medium text-gray-900  mb-4">
      Today's Summary <span class="text-sm">| {{ stats.current.today }} </span>
    </h3>
    <div>
      <div>

        <div class="row-span-1 col-span-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">

          <div class="bg-white overflow-hidden shadow rounded-lg">
            <div class="px-4 py-5 sm:p-6">
              <dl>
                <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
                  Orders taken for next day
                </dt>
                <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
                  {{ stats.current.orders.total.next_day }}
                </dd>
              </dl>
            </div>
          </div>

          <div class="bg-yellow-100 overflow-hidden shadow rounded-lg">
            <div class="px-4 py-5 sm:p-6">
              <dl>
                <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
                  Orders taken for today
                </dt>
                <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
                  {{ stats.current.orders.total.today }}
                </dd>
              </dl>
            </div>
          </div>

          <div class="bg-white overflow-hidden shadow rounded-lg">
            <div class="px-4 py-5 sm:p-6">
              <dl>
                <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
                  Orders taken yesterday
                </dt>
                <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
                  {{ stats.current.orders.total.yesterday }}
                </dd>
              </dl>
            </div>
          </div>

          <div class="bg-white overflow-hidden shadow rounded-lg">
            <div class="px-4 py-5 sm:p-6">
              <dl>
                <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
                  Pending Total Orders
                </dt>
                <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
                  {{ stats.current.orders.total_pending }}
                </dd>
              </dl>
            </div>
          </div>

          <div class="bg-white overflow-hidden shadow rounded-lg">
            <div class="px-4 py-5 sm:p-6">
              <dl>
                <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
                  Total Completed Today
                </dt>
                <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
                  {{ stats.current.orders.completed.today }}
                </dd>
              </dl>
            </div>
          </div>

          <div class="bg-white overflow-hidden shadow rounded-lg">
            <div class="px-4 py-5 sm:p-6">
              <dl>
                <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
                  Total Completed Yesterday
                </dt>
                <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
                  {{ stats.current.orders.completed.yesterday }}
                </dd>
              </dl>
            </div>
          </div>

          <div class="bg-white overflow-hidden shadow rounded-lg">
            <div class="px-4 py-5 sm:p-6">
              <dl>
                <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
                  In Customer Collection
                </dt>
                <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
                  {{ stats.current.orders.customer_collection }}
                </dd>
              </dl>
            </div>
          </div>

          <div class="bg-white overflow-hidden shadow rounded-lg">
            <div class="px-4 py-5 sm:p-6">
              <dl>
                <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
                  Pending Delivery
                </dt>
                <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
                  {{ stats.current.orders.deliveries }}
                </dd>
              </dl>
            </div>
          </div>

          <div class="bg-white overflow-hidden shadow rounded-lg">
            <div class="px-4 py-5 sm:p-6">
              <dl>
                <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
                  Delivery In Progress
                </dt>
                <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
                  {{ stats.current.orders.deliveries_inprogress }}
                </dd>
              </dl>
            </div>
          </div>

        </div>

      </div>


    </div>

    <div class="grid md:grid-cols-3 gap-3 mt-4">
      <div class="mb-3">
        <div class="bg-white overflow-hidden shadow rounded-lg">
          <div>
            <dl class="bg-blue-100 px-4 py-5 sm:p-6">
              <dt class="text-sm leading-5 font-medium text-indigo-500 truncate">
                New Customers
              </dt>
              <dd class="mt-1 text-3xl leading-9 font-semibold text-indigo-600">
                <div class="flex flex-col items-baseline text-3xl leading-8 font-semibold text-indigo-700">
                  {{ stats.current.customers.new.today }} Today
                </div>
                <div class="text-sm text-indigo-400"><span class="text-2xl">{{ stats.current.customers.new.yesterday }}</span> Yesterday </div>
              </dd>
            </dl>
            <dl class="bg-gray-100 px-4 py-5 sm:p-6">
              <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
                Pending Customers
              </dt>
              <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">

                <div class="flex flex-col items-baseline text-3xl leading-8 font-semibold text-indigo-600">
                  {{ stats.current.customers.total.pending }}
                </div>
              </dd>
            </dl>
            <dl class="px-4 py-5 sm:p-6">
              <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
                Registered Customers
              </dt>
              <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">

                <div class="flex flex-col items-baseline text-3xl leading-8 font-semibold text-indigo-600">
                  {{ stats.current.customers.total.active }}
                  <div class="text-sm leading-5 font-medium text-gray-500">
                    out of approved <span class="font-bold">{{ stats.current.customers.total.approved }}</span>
                  </div>
                </div>
              </dd>
            </dl>

          </div>
        </div>
      </div>

      <div class="bg-white rounded-lg shadow mb-3 p-3">
        <h3 class="text-lg py-2 font-bold">Pending Order Count by Customer Location</h3>
        <table class="table table-bordered w-full">
          <tr class="border-b border-gray-500">
            <th class="text-left w-32 py-2">Male'</th>
            <td>{{ stats.current.pending_by_location.male }}</td>
          </tr>

          <tr class="border-b border-gray-500">
            <th class="text-left w-32 py-2">Hulhumale</th>
            <td>{{ stats.current.pending_by_location.hulhumale }}</td>
          </tr>

          <tr class="border-b border-gray-500">
            <th class="text-left w-32 py-2">Island'</th>
            <td>{{ stats.current.pending_by_location.island }}</td>
          </tr>
        </table>
      </div>
    </div>


  </div>
</template>

<script>
// import Layout from '@/Shared/Admin/Layout'
import Layout from '@/Shared/Admin/Layout'

export default {
  metaInfo: { title: 'Dashboard' },
  layout: Layout,
  props: {
    stats: Object
  }
}
</script>
